module.exports = __webpack_public_path__ + "static/media/shopify-connect.b9a2db72.png";